module.exports = __webpack_public_path__ + "front/img/u2.3162735a.jpg";